import * as cheetahGrid from "cheetah-grid"; 

var menuOptions = [
    { value: "=", caption: "LIE e LSE" },
    { value: "<", caption: "LIE" },
    { value: ">", caption: "LSE" },
  ];
  
  let typeOption = new cheetahGrid.columns.type.MenuColumn({
    options: [
      //{ value: 'analitico', label: 'Analítico' },
      { value: 'diario', label: 'Diário' },
      { value: 'sazonal', label: 'Sazonal'}
    ]
  });
  
  let typeAction = new cheetahGrid.columns.action.InlineMenuEditor({
    options: [
      //{ value: 'analitico', label: 'Analítico' },
      { value: 'diario', label: 'Diário' },
      { value: 'sazonal', label: 'Sazonal'}
    ]
  });
  
  
  typeAction.disabled = (record) => {  
    if(record != null || record != undefined){
      let cleanNotSazonal = record.type == "sazonal" && record.indicatorPlan.split("-").length == 2;
      let cleanNotAnalitico = record.type == "analitico" && record.indicatorPlan.split("|").length == 4;
  
      if(!(cleanNotSazonal || cleanNotAnalitico)){
        record.indicatorPlan = "";
      }
      return (record.relationalOperator == 'root' || record.relationalOperator == 'rootnode');
  
    } else {
      return false;
    }
  };
  
  var selector = new cheetahGrid.columns.action.InlineMenuEditor({options: menuOptions, });
  var txtColumnType = new cheetahGrid.columns.type.MenuColumn({options: menuOptions,});
  var inputEditor = new cheetahGrid.columns.action.InlineInputEditor();
  
  selector.disabled = (record) => {
    if(record != null || record != undefined){
      return (record.relationalOperator == 'root' || record.relationalOperator == 'rootnode' ? true : false );
    } else {
      return false;
    }
  };
  
  inputEditor.disabled = (record) => {
    if(record != null || record != undefined){
      return (record.relationalOperator == 'root' || record.relationalOperator == 'rootnode' ? true : false );
    } else {
      return false;
    }
  };

  let IsNumber = (num) => isNaN(parseFloat((num + "").replace(",", ".")))

  const TableWeightIndicator = {
    header: [
        {
          field: "indicatorName",
          caption: "INDICADOR ",
          minWidth: 400,
          width: "41%",
          style(rec) {
            return {
              color: rec.relationalOperator == "root" || rec.relationalOperator == "rootnode" ? 'red' : 'black',
              font: rec.relationalOperator == "root" || rec.relationalOperator == "rootnode" ? "14px Arial Black" : "14px Arial",
            };
          },
          headerStyle: { textAlign: "center", font: "13px sans-serif" },
        },
        {
          field: "relationalOperator",
          caption: "OPERADOR",
          minWidth: 110,
          width: "8%",
          columnType: txtColumnType,
          action: selector,
          style(rec) {
            return {
              color: rec.relationalOperator == "root" || rec.relationalOperator == "rootnode" ? 'red' : 'black',
              font: rec.relationalOperator == "root" || rec.relationalOperator == "rootnode" ? "14px Arial Black" : "14px Arial",
              textAlign: "center"
            };
          },
          headerStyle: { textAlign: "center", font: "13px sans-serif" },
        },
        {
          field: "lowerLimit",
          caption: "RANGE OPERACIONAL (%)",
          minWidth: 135,
          width: "12%",
          action: inputEditor,
          style(rec) {
            return {
              color: rec.relationalOperator == "root" || rec.relationalOperator == "rootnode" ? 'red' : 'black',
              font: rec.relationalOperator == "root" || rec.relationalOperator == "rootnode"? "14px Arial Black" : "14px Arial",
              textAlign: "center"
            };
          },
          headerStyle: { textAlign: "center", font: "13px sans-serif" },
          message(rec){
            if(!rec.upperLimit)
              return null;

            if(((IsNumber(rec.lowerLimit) && rec.lowerLimit != null)) && rec.lowerLimit != ''){
              return 'Por favor, digite apenas número.'
            }
            if(parseFloat(rec.upperLimit.replace(",", ".")) < parseFloat(rec.lowerLimit.replace(",", "."))){
              return 'O range operacional precisa ser menor que o range crítico'
            }
            return null;
          }
        },
        {
          field: "upperLimit",
          caption: "RANGE CRÍTICO (%)",
          minWidth: 135,
          width: "12%",
          action: inputEditor,
          style(rec) {
            return {
              color: rec.relationalOperator == "root" || rec.relationalOperator == "rootnode" ? 'red' : 'black',
              font: rec.relationalOperator == "root" || rec.relationalOperator == "rootnode" ? "14px Arial Black" : "14px Arial",
              textAlign: "center"
            };
          },
          headerStyle: { textAlign: "center", font: "13px sans-serif" },
          message(rec){
            if(!rec.upperLimit)
              return null

            if(((IsNumber(rec.upperLimit) && rec.upperLimit != null) && rec.upperLimit != '' )){
              return 'Por favor, digite apenas número.'
            }
            if(parseFloat(rec.upperLimit.toString().replace(",", ".")) < parseFloat(rec.lowerLimit.toString().replace(",", "."))){
              return 'O range crítico precisa ser maior que o range operacional'
            }
            return null;
          }
        },
        {
          field: "weight",
          caption: "PESO (%)",
          minWidth: 100,
          width: "6%",
          action: inputEditor,
          style(rec) {
            return {
              color: rec.relationalOperator == "root" || rec.relationalOperator == "rootnode" ? 'red' : 'black',
              font: rec.relationalOperator == "root" || rec.relationalOperator == "rootnode"? "14px Arial Black" : "14px Arial",
              textAlign: "center"
            };
          },
          headerStyle: { textAlign: "center", font: "13px sans-serif" },
          message(rec){
            if((IsNumber(rec.weight) && rec.weight != null) && rec.weight != ''){
              return 'Por favor, digite apenas número.'
            }
            return null;
          }
        },
        {
          field: "type",
          caption: "Tipo",
          minWidth: 80,
          width: "6%",
          columnType: typeOption, 
          action: typeAction,
          style(rec) {
            return {
              color: rec.relationalOperator == "root" || rec.relationalOperator == "rootnode" ? 'red' : 'black',
              font: rec.relationalOperator == "root" || rec.relationalOperator == "rootnode"? "14px Arial Black" : "14px Arial",
              textAlign: "center"
            };
          },
          headerStyle: { textAlign: "center", font: "13px sans-serif" },
          message(rec){
            if((IsNumber(rec.weight) && rec.weight != null) && rec.weight != ''){
              return 'Por favor, digite apenas número.'
            }
            return null;
          }
        },
        {
          field: "indicatorPlan",
          caption: "Variável",
          minWidth: 100,
          width: "13%",
          style(rec) {
            return {
              color: rec.relationalOperator == "root" || rec.relationalOperator == "rootnode" ? 'red' : 'black',
              font: rec.relationalOperator == "root" || rec.relationalOperator == "rootnode"? "14px Arial Black" : "14px Arial",
              textAlign: "left"
            };
          },
          action: new cheetahGrid.columns.action.ButtonAction({
            action(rec) {
              if(rec.type == "sazonal"){
                TableWeightIndicator.gridKpiModal(rec)
              } 
              if(rec.type == "analitico"){
                TableWeightIndicator.showModalGreatness(rec)
              }
            },
          }),  
          headerStyle: { textAlign: "center", font: "13px sans-serif" },
        },
    ],
    gridKpiModal: () => {
        console.log('Teste')
    },
    showModalGreatness: () =>{
  
    }
}

export default TableWeightIndicator